import { Injectable } from '@angular/core';
import { ApiService } from "../api-service/api.service"
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class RewardsService {

  private _rewards: BehaviorSubject<any>
  private _rewardData: BehaviorSubject<any>
  private _rewardId

  constructor(private apiService: ApiService) {
    this._rewards = new BehaviorSubject({})
    this._rewardData = new BehaviorSubject({})
    
  }

  get rewards() {
    return this._rewards
  }

  get rewardData(){
    return this._rewardData
  }

  set rewardId(id){
    console.log(id,'In rewardId')
    this._rewardId = id
    this.retrieveReward()

  }

  retrieveReward(){
    
    console.log(this._rewardId,'in retrieve reward')

    this.apiService.request('GET', '/reward/'+this._rewardId).then((response)=>{
    console.log("RewardsService -> getRewardByID -> response", response)

      if(response.type == 3 || response.type == 5){
        response.reward_value = response.discount_amount
      }

      if(response.type == 1){
        response.reward_value = response.cashback_amount
      }

      this._rewardData.next(response)
      
    })
    .catch(error=>{
      console.log(error)
    })

  }

  retrieveRewards() {
    this.apiService.request('GET', '/rewards?type=1,3,5')
    .then((response)=>{      
      this._rewards.next(response)
    })
    .catch(error=>{
      console.log(error)
    })
  }

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/app/rewards-service/rewards.service.ts